import { AVATAR_TYPES, DEFAULT_AVATAR_TYPES } from '../Constants';
import { Type } from '../types/SharedPropTypes';
import { ValueOf } from '../types/Utils';

export const getDefaultAvatarType = (
  type?: Type
): ValueOf<typeof DEFAULT_AVATAR_TYPES> | undefined => {
  if (type && type in AVATAR_TYPES) {
    return AVATAR_TYPES[type];
  }
  return undefined;
};
